import React, { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSiteConfig } from "../context/SiteConfigContext";

const Header = () => {
  const { siteConfig } = useSiteConfig();
  const topBarRef = useRef(null);
  const navbarRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth > 1024) {
        const isScrolled = window.scrollY > 20;

        if (topBarRef.current && navbarRef.current) {
          if (isScrolled) {
            topBarRef.current.classList.add("top-bar-hidden");
            navbarRef.current.classList.add("navbar-scrolled");
          } else {
            topBarRef.current.classList.remove("top-bar-hidden");
            navbarRef.current.classList.remove("navbar-scrolled");
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // navigation close
  const closeNavbar = () => {
    const collapseEl = document.getElementById("mainNavContent");
    if (collapseEl && collapseEl.classList.contains("show")) {
      if (window.bootstrap?.Collapse) {
        const bsCollapse = window.bootstrap.Collapse.getInstance(collapseEl);
        if (bsCollapse) bsCollapse.hide();
      } else {
        collapseEl.classList.remove("show");
      }
      const toggler = document.querySelector(".mrv-custom-toggler");
      if (toggler) toggler.classList.add("collapsed");
    }
  };

  //  Route change hone par close
  useEffect(() => {
    closeNavbar();
  }, [location]);

  // Bahar click/tap karne par close
  useEffect(() => {
    const handleOutsideClick = (e) => {
      const collapseEl = document.getElementById("mainNavContent");
      const isOpen = collapseEl?.classList.contains("show");
      if (
        isOpen &&
        navbarRef.current &&
        !navbarRef.current.contains(e.target)
      ) {
        closeNavbar();
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, []);

  return (
    <>
      <div ref={topBarRef} className="mrv-top-bar d-none d-lg-block">
        <div className="container-fluid px-lg-5 px-3">
          <div className="d-flex justify-content-between align-items-center mrv-top-flex">
            <div className="mrv-top-left py-2">
              <span className="me-3">
                <i className="bi bi-geo-alt-fill" /> {siteConfig.address}
              </span>
              <span className="me-3">
                <i className="bi bi-telephone-fill" /> {siteConfig.landline1},{" "}
                {siteConfig.landline2}
              </span>
              <span>
                <i className="bi bi-envelope-fill" />{" "}
                <a
                  href={`mailto:${siteConfig.email}`}
                  className="text-white text-decoration-none"
                >
                  {siteConfig.email}
                </a>
              </span>
            </div>
            {/* RIGHT : Admission */}
            <div className="mrv-top-right">
              {siteConfig?.erp_registration_link && (
                <a href={siteConfig.erp_registration_link} className="mrv-admission-tag animate-pulse" target="_blank">
                  <i className="bi bi-megaphone-fill me-1" />
                  Admission Open {siteConfig.admission_batch}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>

      <nav
        ref={navbarRef}
        className="navbar navbar-expand-lg fixed-top mrv-main-nav"
        id="mrvNavbar"
      >
        <div className="container-fluid px-lg-5 px-3">
          <Link
            className="navbar-brand mrv-nav-logo d-flex align-items-center"
            to="/"
          >
            <div className="logo-circle-container">
              <img
                src={siteConfig.logo}
                // src={`${process.env.PUBLIC_URL}/assets/images/logo2.png`}
                alt="MRV Logo"
                loading="lazy"
                className="mrv-logo-img"
              />
            </div>
          </Link>
          <button
            className="navbar-toggler mrv-custom-toggler collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNavContent"
          >
            <div className="mrv-hamburger">
              <span className="line-1" />
              <span className="line-2" />
              <span className="line-3" />
            </div>
          </button>
          <div className="collapse navbar-collapse" id="mainNavContent">
            <ul className="navbar-nav ms-auto align-items-center mrv-nav-list">
              <li className="nav-item">
                <Link to="/" className="nav-link active">
                  Home
                </Link>
              </li>

              <li className="nav-item dropdown premium-dropdown">
                <Link
                  to=""
                  className="nav-link dropdown-toggle custom-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  About Us
                  <svg
                    className="ms-1 dropdown-icon"
                    width={12}
                    height={12}
                    viewBox="0 0 16 16"
                  >
                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                  </svg>
                </Link>
                <ul className="dropdown-menu premium-menu">
                  <li className="animate-item">
                    <Link
                      to="/our-leader"
                      className="dropdown-item custom-glow"
                    >
                      Our Leaders
                    </Link>
                  </li>
                  <li className="animate-item">
                    <Link className="dropdown-item custom-glow" to="/about-us">
                      About School
                    </Link>
                  </li>
                  <li className="animate-item">
                    <Link
                      to="/our-philosophy"
                      className="dropdown-item custom-glow"
                    >
                      Our Philosophy
                    </Link>
                  </li>
                  <li className="animate-item">
                    <Link className="dropdown-item custom-glow" to="/alumni">
                      Alumni
                    </Link>
                  </li>
                  <li className="animate-item">
                    <Link className="dropdown-item custom-glow" to="/branches">
                      Branches
                    </Link>
                  </li>
                  <li className="animate-item">
                    <Link
                      className="dropdown-item custom-glow"
                      to="/visitors-and-guests"
                    >
                      Visitors & Guests
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/academics">
                  Academics
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link className="nav-link" to="facilities">
                  Facilities
                </Link>
              </li> */}
              <li className="nav-item dropdown premium-dropdown">
                <Link
                  to="#"
                  className="nav-link dropdown-toggle custom-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Facilities
                  <svg
                    className="ms-1 dropdown-icon"
                    width={12}
                    height={12}
                    viewBox="0 0 16 16"
                  >
                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                  </svg>
                </Link>
                <ul className="dropdown-menu premium-menu">
                  <li className="animate-item">
                    <Link
                      to="/smart-classrooms"
                      className="dropdown-item custom-glow"
                    >
                      Smart Classrooms
                    </Link>
                  </li>

                  <li className="animate-item">
                    <Link
                      to="/kyan-board"
                      className="dropdown-item custom-glow"
                    >
                      Kyan Smart Board
                    </Link>
                  </li>
                  <li className="animate-item">
                    <Link
                      className="dropdown-item custom-glow"
                      to="/learning-labs"
                    >
                      Learning Labs
                    </Link>
                  </li>
                  <li className="animate-item">
                    <Link
                      className="dropdown-item custom-glow"
                      to="/library-reading-room"
                    >
                      Library & Reading Room
                    </Link>
                  </li>
                  <li className="animate-item">
                    <Link className="dropdown-item custom-glow" to="/art-craft">
                      Art & Craft Studio
                    </Link>
                  </li>
                  <li className="animate-item">
                    <Link
                      className="dropdown-item custom-glow"
                      to="/music-room"
                    >
                      Music Room
                    </Link>
                  </li>
                  <li className="animate-item">
                    <Link
                      className="dropdown-item custom-glow"
                      to="/medical-room"
                    >
                      Medical Checkup
                    </Link>
                  </li>
                  <li className="animate-item">
                    <Link
                      className="dropdown-item custom-glow"
                      to="/physical-education"
                    >
                      Sports & Physical Education
                    </Link>
                  </li>
                  <li className="animate-item">
                    <Link className="dropdown-item custom-glow" to="/tuck-shop">
                      Tuck Shop / Canteen
                    </Link>
                  </li>
                  <li className="animate-item">
                    <Link
                      className="dropdown-item custom-glow"
                      to="/cctv-surveillance"
                    >
                      CCTV Surveillance
                    </Link>
                  </li>
                  <li className="animate-item">
                    <Link
                      className="dropdown-item custom-glow"
                      to="/mid-day-meal"
                    >
                      Mid-Day Meal Facility
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="news-and-events">
                  News &amp; Events
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="achievements">
                  Achievements
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="gallery">
                  Gallery
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link btn-mrv-contact" to="contact-us">
                  Contact Us
                </Link>
              </li>
              <li className="nav-item dropdown premium-dropdown">
                <Link
                  to=""
                  className="nav-link dropdown-toggle custom-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Other Information
                  <svg
                    className="ms-1 dropdown-icon"
                    width={12}
                    height={12}
                    viewBox="0 0 16 16"
                  >
                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                  </svg>
                </Link>
                <ul className="dropdown-menu premium-menu">
                  <li className="animate-item">
                    <Link
                      to="/faculty"
                      className="dropdown-item custom-glow"
                      href="leaders.html"
                    >
                      Our Faculty
                    </Link>
                  </li>
                  <li className="animate-item">
                    <Link className="dropdown-item custom-glow" to="career">
                      Career
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
